export default __webpack_public_path__ + "static/media/constriction.d152472e.png";